import React, { useState } from 'react'
import Header from '../components/global/Header'
import Footer from '../components/global/Footer'
import pcm from '../assets/images/pcm.png'
import { Link } from "react-router-dom"


const CartData = [
  {
    no: 1,
    picture: { pcm },
    name: "Paracetamol",
    weight: "500mg",
    price: "₦1,570"
  },


];
function CartDetails() {
  const price = 1570
  const [itemsNo, setItemsNo] = useState(1);

  const AddItemsNo = () => {
    setItemsNo((prev) => prev + 1);
  };
  const SubtractItemsNo = () => {
    if (itemsNo > 0) {
      setItemsNo((prev) => prev - 1);
    }
  };
  const calculateTotal = () => {
    return itemsNo * price;
  };
  const calculateVat = () => {
    return Math.floor(itemsNo * price * 0.21);
  };
  const Total = () => {
    return calculateVat() + calculateTotal();
  };

  return (
    <div>
      <Header />
      <div className="container carttotal">
        <h1>
          Cart <span style={{ fontSize: "18px" }}>{CartData.length} item(s)</span>
        </h1>
        <div className="row">
          <div className="col-lg-8">
            <div className="col-12">
              <div className="table-responsive-md cartdetails">
                <table className="table">
                  <thead>
                    <th>PRODUCT</th>
                    <th>PRICE</th>
                    <th>QUANTITY</th>
                    <th>TOTAL</th>
                  </thead>
                  <tbody>

                    {CartData.map(item => (
                      <tr>
                        <td style={{ display: 'flex', alignItems: 'center' }} >
                          <img style={{ float: "left" }} src={pcm} alt="" />
                          <div>
                            {item.name}<br />
                            <span>{item.weight}</span>
                          </div>

                        </td>
                        <td>{item.price}</td>
                        <td>
                          <div className="cartdetails__number">
                            <button
                              onClick={() => SubtractItemsNo()}
                              className="cartdetails__number__control"
                            >
                              -
                               </button>

                            <input
                              type="text"
                              className="cartdetails__number__count"
                              value={itemsNo}
                            />

                            <button
                              onClick={() => AddItemsNo()}
                              className="cartdetails__number__control"
                            >
                              +
                              </button>
                          </div>
                        </td>
                        <td>₦{calculateTotal()}</td>
                      </tr>

                    ))}

                  </tbody>

                </table>
                <hr />
              </div>
            </div>
          </div>
          <div className="col-lg-4">
            <div className="col-12">
              {/* Order Summary */}
              <div className="order">
                <p>Order Summary</p>
                <table className=" table table-borderless">
                  <tbody>
                    <tr>
                      <td>Item(s) Total</td>
                      <td className="price">₦{calculateTotal()}</td>
                    </tr>
                    <tr>
                      <td> VAT(21%)</td>
                      <td className="price">₦{calculateVat()}</td>
                    </tr>
                  </tbody>
                </table>
              </div>
              {/* Total */}
              <div className="total">
                <table className=" table table-borderless">
                  <tbody>
                    <tr>
                      <td className="totalh">Total Price</td>
                      <td>
                        {" "}
                        <Link to="/billing-info">
                          <button className="checkbtn">CHECKOUT</button>
                        </Link>

                      </td>
                    </tr>
                    <tr>
                      <td className="price">₦{Total()}</td>

                      <td>
                        {" "}
                        <Link to="/user-home">
                          <button className="keepbtn">KEEP SHOPPING</button>
                        </Link>

                      </td>
                    </tr>
                  </tbody>
                </table>
              </div>
            </div>
          </div>
        </div>
      </div>
      <Footer />
    </div>
  );
}

export default CartDetails;
